import './App.css';
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoginContainer from './Components/Login/container';
import LocationPage from './Components/VmList/LocationPage.jsx';
import VmlistContainer from './Components/VmList/container.js';
import VmInventoryContainer from './Components/VmInventory/container.js';
import MyCartContainer from './Components/MyCart/Container.js';
import PaymentOptionContainer from './Components/PaymentOption/container.js';
import HelpAndSupport from './Components/HelpandSupport/container.js'
import Game from './Components/Game/component.jsx';
import Guidelines from './Components/Game/Guidelines/index.js';
import BusinessPayment from './Components/BusinessPayment/container.js';
import DpHistoryContainer from './Components/DpHistory/container.js';
import ProductDetailsContainer from './Components/ProductDetails/container.js';
import PickupOptions from './Components/PickupOptions/Component.jsx';
import UserprofileContainer from './Components/Userprofile/container.js';
import Orders from './Components/Orders/container.js';
import ReferEarnContainer from './Components/Refer&Earn/container.js';
import Settings from './Components/Settings/component.jsx';
import DeleteAccountContainer from './Components/DeleteAccount/container.js';
import FaqHelpSupport from './Components/Faq-Help-Support/container.js';
import FaqDetailsContainer from './Components/FaqDetails/container.js'
import GiftCard from './Components/GiftCard/component.jsx'
import Paytm from './Components/Paytm/container.js';
import HelpAndSupportContainer from './Components/HelpandSupport/container.js';
import ActiveOrderContainer from './Components/ActiveOrder/container.js';
import OrderDeatailsContainer from './Components/OrderDetails/container.js';
import KioskNumberModal from './Components/VendOrder/KioskNumberModal.jsx';
import IncorrectResponseModal from './Components/VendOrder/IncorrectResponseModal.jsx';
import VendingProgress from './Components/VendOrder/VendingProgress.jsx';
import TagOrder from './Components/TagOrder/component.jsx';
import TagOrderContainer from './Components/TagOrder/container.js';
import ProfileScreen from './Components/Userprofile/1.jsx';
import EditProfile from './Components/EditProfile/component.jsx';
import TagListContainer from './Components/TagpayList/container.js';
import OrderHelpSection from './Components/HelpandSupport/Help-or-Machine/OrderHelpSection.jsx';
import TagAddContainer from './Components/TagAdd/container.js';
import TagDirRechargeContainer from './Components/TagAdd/containerRecharge.js';
import TagRechargeContainer from './Components/TagAdd/containerRecharge.js';
import TagpayHistoryContainer from './Components/TagpayHistory/container.js';
import GlobalSearchContainer from './Components/GlobalSearch/container.js';
import VerifiedSuccess from './Components/VendOrder/vendingSuccess.jsx';
import Fail from './Components/VendOrder/Fail.jsx';
import SlideExpandableCard from './Components/EnteryPoint/component.jsx';
import { useEffect } from 'react';
import Categories from './category';
import BpHistoryContainer from './Components/BusinessPayment-history/container.js';
import OrderStatus from './helpTest.jsx';
import OrderStatusDesktop from './helpTest1.jsx';
import AuthFlow from './Components/Auth_Remeed/Auth.jsx';

import RefundStatus from './Components/HelpandSupport/New_HELP/new_help.jsx';
import NoCoupons from './Components/2.jsx';
import Auth from './Components/Auth_Remeed/container.js';
import GiftCardScreen from './Components/A_Gift/Component.jsx';
import Cliam from './Components/A_Redeem/container.js';
import Digital_Details_Container from './Digital_Details/container.js';

const Help=()=>{
  const navigate=useNavigate();
  useEffect(()=>{
 navigate('/help&support')
  },[])
 
  
}
function App() {
  return (
    <Router   future={{
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  }}>

      <ToastContainer />
      <Routes>

         <Route path="/entryPointQr" element={<SlideExpandableCard />} />

        <Route path="/login" element={<LoginContainer />} />
           <Route path="/help" element={<Help />} />
        <Route path="/" element={<VmlistContainer />} />
        <Route path='/items' element={<VmInventoryContainer />} />
        <Route path='/mycart' element={<MyCartContainer />} />
        <Route path='/paymentoptions' element={<PaymentOptionContainer />} />
        <Route exact path="/game" element={< Game />} />
        <Route exact path="/link/bp" element={<BusinessPayment />} />
        <Route exact path="/dphistory" element={<DpHistoryContainer />} />
        <Route exact path="/productdetails/:machine_id/:mv_id/:slot_id" element={<ProductDetailsContainer />} />
        <Route exact path='/pickupOptions' element={<PickupOptions />} />
        <Route exact path="/profile" element={<UserprofileContainer />} />
        <Route exact path="/orders" element={<Orders />} />
        <Route exact path="orders/Details/:orderId" element={<OrderDeatailsContainer />} />
        <Route exact path='/refer&earn' element={<ReferEarnContainer />} />
        <Route exact path="/settings" element={< Settings />} />
        <Route exact path="/deleteaccount" element={< DeleteAccountContainer />} />
        <Route exact path="/faq-help-support" element={<FaqHelpSupport />} />

        <Route exact path="/faqDetails/:topicId" element={<FaqDetailsContainer />} />
        <Route exact path='/giftcard' element={<GiftCard />} />
        <Route exact path="/paytm" element={<Paytm />} />
        <Route exact path="/help&support" element={< HelpAndSupportContainer />} />
        <Route path='/guideLines' element={<Guidelines />} />
        <Route path="/pickupOptions/:orderId" element={<PickupOptions />} />

        <Route path="/activeOrder/:status/:orderId" element={<ActiveOrderContainer />} />
        <Route path="/vendOrder/number/:orderId" element={<KioskNumberModal />} />
        <Route path="vendOrder/timeout/:orderId" element={<IncorrectResponseModal />} />
        <Route exact path='/vendOrder/failed/:orderId' element={<Fail />} />

        <Route exact path='/vendOrder/success/:orderId' element={<VerifiedSuccess />} />
        <Route path="/vendOrder/vendingprogress/:orderId" element={<VendingProgress />} />
        <Route path="/tagOrderId" element={<TagOrderContainer />} />

        <Route path="/editprofile" element={<EditProfile />} />
        <Route path="/taglist" element={<TagListContainer />} />
        <Route path="/orderhelpsection" element={<OrderHelpSection />} />
        <Route path="/orderhelpsection" element={<OrderHelpSection />} />
        <Route path="/addtag" element={<TagAddContainer />} />
        <Route path="/TagRecharge" element={<TagRechargeContainer />} />
        <Route exact path="/taghistory/:uId" element={<TagpayHistoryContainer />} />
        <Route path="/GlobalSearch" element={<GlobalSearchContainer />} />
        

             <Route path="/category" element={<Categories />} />
<Route exact path='/ordersearch' element={<HelpAndSupport/>}/>
       
             <Route path="/bphistory" element={<BpHistoryContainer/>} />
               <Route path="/orderStatus" element={<OrderStatus/>} />
            <Route path="/orderStatus1" element={<OrderStatusDesktop/>} />
              <Route path="/1" element={<RefundStatus/>} />
      <Route path="/AuthFlow" element={<Auth />} /> 
     <Route path="/digital" element={<Cliam />} /> 
     <Route path="/digital_details" element={<Digital_Details_Container />} /> 
     <Route path="/gift" element={<GiftCardScreen/>}/>
{/*  <Route path="/2" element={<NoCoupons />} />  */}
      </Routes>
    </Router>
  );
}

export default App;
